import React, { useEffect, useRef } from 'react';
import '../Report/ledgercss.css';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Grid, Paper } from '@mui/material';
import ReactToPrint from 'react-to-print';
import {fetchLedgerData,selectSalesLedgerData,selectSalesLedgerLoading,fetchLedgerOpeningBal,selectSalesLedgerOpeningBal } from '../../Store/PHPSlice/ReportApi/reportApi';
import FirmHeaderImg from '../FieldsComponents/FirmHeaderImg';

const SalesLedgerPrint  = () => {
  const { firmId, partyNm,fromDt,toDt,cat } = useParams();
  const dispatch = useDispatch();
  const componentRef = useRef();

  const SalesOpeningBal = useSelector(selectSalesLedgerOpeningBal );
  const opening = SalesOpeningBal?.[0];


 const SalesData = useSelector(selectSalesLedgerData );
  
const ledgerLoading = useSelector(
  (state) => state.salesLedger.ledgerLoading
);
const openingLoading = useSelector(
  (state) => state.salesLedger.openingLoading
);  

  useEffect(() => {
    dispatch(fetchLedgerData({ firmId: firmId, partyId:partyNm,fmdt:fromDt,todt:toDt,cat:cat }));
    dispatch(fetchLedgerOpeningBal({ firmId: firmId, partyId:partyNm,fmdt:fromDt,todt:toDt,cat:cat }));
   // dispatch(fetchAdavanceDataPrint({ id: Id, type }));
  }, [firmId, partyNm,fromDt,toDt,cat, dispatch]);

if (ledgerLoading || openingLoading) return <p>Loading...</p>;
  if (!SalesData) return <p>No Ledger data found</p>;
const formatDate = (dt) => {
  if (!dt || dt === "0") return "";
  return new Date(dt).toLocaleDateString("en-GB");
};
// OPENING
const openingDebit = Number(opening?.opening_bal_debit || 0);
const openingCredit = Number(opening?.opening_bal_credit || 0);

// TRANSACTIONS
let txnDebit = 0;
let txnCredit = 0;

SalesData.forEach(row => {
  txnDebit += Number(row.debitamt || 0);
  txnCredit += Number(row.creditamt || 0);
});

// TOTAL
const totalDebit = openingDebit + txnDebit;
const totalCredit = openingCredit + txnCredit;

// CLOSING
const closingBalance = totalDebit - totalCredit;

const closingDebit = closingBalance > 0 ? closingBalance : 0;
const closingCredit = closingBalance < 0 ? Math.abs(closingBalance) : 0;


const rowStyle = (ctype, settlement_sts) => {
  // Settlement priority (dark red)
  // if ( (ctype === "Sale" && (settlement_sts !== 0))) {
  //   return { color: "#ff0000", fontWeight: "bold" };
  // }
  // else if ( (ctype === "Sale Rcpt " && (settlement_sts !== 0))) {
  //   return { color: "#ff0000", fontWeight: "bold" };
  // }
  //  else if ( (ctype === "Advance Rcpt " && (settlement_sts !== 0))) {
  //   return { color: "#ff0000", fontWeight: "bold" };
  // }
  //  else if ( (ctype === "RT Goods Rcpt " && (settlement_sts !== 0))) {
  //   return { color: "#ff0000", fontWeight: "bold" };
  // }
  // else
  // {

  switch (ctype) {
    case "Sale":
      return { color: "#1e3a8a", fontWeight: "bold" }; // dark blue
    case "Sale Rcpt":
      return { color: "#065f46", fontWeight: "bold" }; // dark green
    case "Advance Rcpt":
      return { color: "#7c2d12", fontWeight: "bold" }; // maroon
    case "RT Goods Rcpt":
      return { color: "#4c1d95", fontWeight: "bold" }; // purple
    default:
      return { color: "#000", fontWeight: "bold" };
  // }
}
};




  const th = {
    border: '1px solid #000',
    backgroundColor: '#f3f4f6',
    fontWeight: 'bold',
    fontSize: '12px',
    textAlign: 'center'
  };

  const td = {
    border: '1px solid #000',
    fontSize: '12px',
    textAlign: 'center'
  };


  return (
    <Grid item xs={12}>
      <Paper>
        <div ref={componentRef} style={{ padding: '20px' }}>
{opening?.firmId && <FirmHeaderImg firmId={opening.firmId} />}

          {/* HEADER */}
<table width="100%" style={{ textAlign: "center" }}>
  <tbody>
    {/* <tr>
      <td style={{border:"1px solid #fff"}}>
        <h1 style={{ margin: 0, color: "#0f172a" }}>
          {opening?.firmNm}
        </h1>
        <div style={{ fontSize: "13px" }}>
          {opening?.firmAddress}
        </div>
      </td>
    </tr> */}

    <tr>
      <td style={{ paddingTop: "8px" ,border:"1px solid #fff"}}>
        <h3 style={{ margin: 0 }}>
          Ledger Account : {opening?.partyNm}
        </h3>
        <div style={{ fontSize: "13px" }}>
          {opening?.partyAddress}
        </div>
      </td>
    </tr>

    {fromDt !== "0" && toDt !== "0" && (
      <tr>
        <td style={{ paddingTop: "6px", fontSize: "13px",borderRight:"1px solid #fff",borderLeft:"1px solid #fff",borderBottom:"1px solid #fff" }}>
          <b>From :</b> {formatDate(fromDt)} &nbsp;&nbsp;
          <b>To :</b> {formatDate(toDt)}
        </td>
      </tr>
    )}
  </tbody>
</table>

<hr style={{ border: "1px solid #000", margin: "12px 0" }} />


<hr style={{borderBottom:"2px dashed #000"}}></hr>
<table width="100%" cellPadding="6" style={{ borderCollapse: "collapse" }}>
  <thead>
<tr>
  <th align='left' style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>Date</th>
   <th align='left' style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>Type</th>
    <th style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>Bill No.</th>
     <th style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>Receipt No.</th>
     <th style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>Narration</th>
      <th  align='right' style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>Debit</th>
       <th align='right' style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>Credit</th>
</tr>
</thead>
  <tbody>
    {/* OPENING BALANCE */}
    <tr style={{ fontWeight: "bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff" }}>
      <td colSpan={5} align="right" style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>Opening Balance</td>
       <td align="right" style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}} >{opening?.opening_bal_debit || "0"}</td>
      <td align="right" style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>{opening?.opening_bal_credit || "0"}</td>
    </tr>
   {/* LEDGER ROWS */}
  {SalesData.map((row, index) => (
  <tr key={index} style={rowStyle(row.ctype, row.settlement_sts)}>
      <td align="left" style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>{formatDate(row.dt)}</td>
      <td align="left" style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>{row.ctype}</td>
      <td align="center" style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>{row.bill}</td>
      <td align="center" style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>{row.receipt_no}</td>
      <td align="left" style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>{row.narration}</td>
      <td align="right" style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>{row.debitamt > 0 ? row.debitamt : ""}</td>
      <td align="right" style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>{row.creditamt > 0 ? row.creditamt : ""}</td>
    </tr>
  ))}
  {/* TOTAL ROW */}
<tr style={{ fontWeight: "bold", borderTop: "2px solid #000" }}>
  <td colSpan={5} style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}} align="right">Total</td>
  <td align="right" style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>{totalDebit.toFixed(2)}</td>
  <td align="right" style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>{totalCredit.toFixed(2)}</td>
</tr>

{/* CLOSING BALANCE */}
<tr style={{ fontWeight: "bold", borderTop: "2px solid #000" }}>
  <td colSpan={5} align="right" style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>Closing Balance</td>
  <td align="right" style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>{closingDebit > 0 ? closingDebit.toFixed(2) : "0"}</td>
  <td align="right" style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>{closingCredit > 0 ? closingCredit.toFixed(2) : "0"}</td>
</tr>



</tbody>
</table>


      
        </div>

        <div style={{ margin: '20px' }}>
          
          <ReactToPrint
            trigger={() => <Button variant="contained">PRINT</Button>}
            content={() => componentRef.current}
          />
        </div>
      </Paper>
    </Grid>
  );
};

export default SalesLedgerPrint ;
